import { render } from "./DocumentInternalStatus.vue?vue&type=template&id=d6fada46&scoped=true"
import script from "./DocumentInternalStatus.vue?vue&type=script&lang=js"
export * from "./DocumentInternalStatus.vue?vue&type=script&lang=js"

import "./DocumentInternalStatus.vue?vue&type=style&index=0&id=d6fada46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6fada46"]])

export default __exports__